<template>
  <div
    :class="[
      'AddToHomeScreen shadow-lg duration-500 fixed w-gr-11 md:w-auto z-40 bottom-gr-6 left-1/2 -translate-x-1/2 rounded-lg bg-white p-gr-5 flex justify-center items-center',
      show ? 'opacity-100 translate-y-0' : 'pointer-events-none opacity-0 translate-y-gr-8',
    ]"
  >
    <span class="text-gray-700 flex flex-wrap items-center">
      Tap
      <span
        class="mx-gr-4 inline-block contain-svg text-[#3578F7] h-gr-6 w-gr-5 -mt-gr-half-4"
        v-html="$getIconHtml('ios-share')"
      ></span>
      below, then <br />
      <span class="flex items-center">
        <span
          class="md:ml-gr-4 mr-gr-3 inline-block contain-svg h-gr-6 w-gr-5 text-black"
          v-html="$getIconHtml('ios-add')"
        ></span
        >&nbsp;Add to Home Screen</span
      >
    </span>
    <button @click="onHide" class="ml-gr-6 text-xs uppercase leading-gr-5 link underline">
      Hide
    </button>
    <span
      class="absolute z-10 top-full left-1/2 bg-white rotate-45 -translate-x-1/2 -translate-y-1/2 w-gr-6 h-gr-6 -ml-gr-1"
    ></span>
  </div>
</template>

<script>
  import { getCookie, setCookie } from '@/Utils/cookies';

  export default {
    name: 'AddToHomeScreen',

    data() {
      return {
        show: false,
      };
    },

    mounted() {
      // Only show if user has verified email and a set password
      if (
        this.$page.props.user &&
        this.$page.props.user.email_verified_at &&
        !this.$page.props.user.needs_reset
      ) {
        if (navigator.userAgent.indexOf('iPhone') !== -1) {
          var hasCookie = getCookie('ios');
          var notInAppMode = 'standalone' in window.navigator && !window.navigator.standalone;
          if (!hasCookie && notInAppMode) {
            setTimeout(() => {
              this.show = true;
            }, 500);
          }
        }
      }
    },

    methods: {
      onHide() {
        setCookie('ios', 'true', 365);
        this.show = false;
      },
    },
  };
</script>

<!-- <style lang="scss" src="./AddToHomeScreen.scss" scoped></style> -->
